require([
    'services',
    'jquery',
    'semantic',
    'ch_selectors',
    'ch_maps',
    'ch_welcome_overlay',
    'ch_semantic_wishlist',
    'ch_header'
], function() {
    var $showMoreReviewsBtn;
    var $showMoreClassesBtn;
    var $showMoreTeachersBtn;
    var $reviewsSection;
    var $coursesSection;
    var $provider_review_loader;
    var $provider_course_loader;

    $(function() {
        $showMoreReviewsBtn = $('#show-more-reviews');
        $showMoreClassesBtn = $('#courses-section .show-more-classes');
        $showMoreTeachersBtn = $('#show-more-teachers');
        $reviewsSection = $('#reviews-section');
        $coursesSection = $('#courses-section');
        $provider_review_loader = $('#provider-review-loader');
        $provider_course_loader = $('#provider-course-loader');

        initRating();
        initButtons();
    });

    function initRating() {
        $('.ui.rating').rating(
            {
                maxRating: 5,
                interactive: false
            }
        );
    }

    function initButtons() {
        $showMoreClassesBtn.on('click', function(e) {
            $self = $(this);
            e.preventDefault();
            $provider_course_loader.show();
            $showMoreClassesBtn.hide();
            var offset = $self.data('offset');
            $.ajax({
                type: 'GET',
                url: '/provider/get-additional-provider-courses',
                dataType: 'html',
                data: {
                    provider_id: CH.providerId,
                    offset: offset
                },
                success: function (html) {
                    $coursesSection.append(html);
                    $coursesSection.slideDown('fast');
                    $provider_course_loader.hide();

                    // Bind on new button
                    $showMoreClassesBtn = $('#courses-section .show-more-classes');
                    initButtons();
                }
            });

            var classes = $('.more-class-name');
            classes.show();

            $showMoreClassesBtn.hide();
        });

        $showMoreTeachersBtn.on('click', function(e) {
            e.preventDefault();

            var teachers = $('.more-teacher-name');
            teachers.show();

            $showMoreTeachersBtn.hide();
        });

        $showMoreReviewsBtn.on('click', function(e) {
            e.preventDefault();
            $provider_review_loader.show();
            $showMoreReviewsBtn.hide();
            $.ajax({
                type: 'GET',
                url: '/provider/get-additional-provider-reviews',
                dataType: 'html',
                data: {
                    provider_id: CH.providerId
                },
                success: function (html) {
                    $reviewsSection.append(html);
                    $reviewsSection.slideDown('fast');
                    $provider_review_loader.hide();

                    initRating();
                }
            });
        });

        $('#scroll-to-reviews').on('click', function(e) {
            CH.scrollToElement($('#provider-reviews-section'));
        });

        // handle chat with us!
        $('.js-olark-open').click(function (e) {
            e.preventDefault();
            olark('api.box.expand');
        });
    }
});
